 <template>
  <div id="app" class="app">
    <p style="display: none;">Is it Idle? - {{ isIdle }}</p>
    <router-view />
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'app',
  data () {
    return {
      // Temporary config for 2.1.
      contextConfig: {
        gradient: true,
        shadow: 'lg', // 3 states: 'sm', 'lg', undefined (no shadow).
        invertedColor: false,
      },
      displayMyComp:false,
    }
  },
  provide () {
    return {
      contextConfig: this.contextConfig,
    }
  },
  computed: {
    async isIdle() {
      if(this.$store.state.idleVue.isIdle){
        await localStorage.removeItem('LoggedUser')
        await localStorage.removeItem('UserMianFosa') 
        await localStorage.removeItem('UserFosas') 
        await localStorage.removeItem('UserNotifications')       
        return this.$router.push({name: "login" });
      }else{
        return this.$store.state.idleVue.isIdle;
      }      
    }
  },
  methods:{
    checkConenction () {
      const self = this
      axios.get(`${this.$apiUrl}pingAddress`)
      .then(function (res) { 
        var response = res.data
        if(response.success == 0){
          self.logout();
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },

    async logout(){
      await localStorage.removeItem('LoggedUser')
      await localStorage.removeItem('UserMianFosa') 
      await localStorage.removeItem('UserFosas') 
      await localStorage.removeItem('UserNotifications')
      this.showToast(`Could not establish a connection to your sacco please try again later`, {
        position: 'bottom-right',
        icon: "fa-times",
        duration: 10000,
        //10000
      })
      setTimeout( () => this.$router.push({name: "login" }), 10000);       
    },
  },
  watch: {
    // Temporary colors fix for 2.1.
    'contextConfig.invertedColor' (val) {
      const invertedColorClass = 'va-inverted-color'
      if (val) {
        document.body.classList.add(invertedColorClass)
      } else {
        document.body.classList.remove(invertedColorClass)
      }
    },
  },
  created(){
    this.checkConenction();
  }
}
</script>

<style lang="scss">
@import '../sass/main.scss';

body {
  height: 100%;

  #app {
    height: 100%;
  }
}
</style>
